import {
  Button,
  SubmitButton,
  Tooltip,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';

// The library Modal renders `actionsProps` as plain Buttons with nowhere to
// hang a Tooltip, and a disabled MUI button sets pointer-events: none, so a
// Tooltip around it would never open. Modal takes `actions` as a full footer
// replacement, which is what lets the span below sit between the Tooltip and
// the disabled Confirm.
//
// Only the refused path renders this. A permitted user keeps the footer the
// library builds.
const PermissionGatedActions = ({ actionsProps, tooltip }) => {
  const [dismissProps, confirmProps] = actionsProps;
  const { children: dismissLabel, ...dismissRest } = dismissProps;
  const { children: confirmLabel } = confirmProps;

  // The library resolves an unset `variant` to "text" when `children` is
  // exactly the string "Cancel" or "No", and to "primary" otherwise. Deny's
  // and Cancel's dismiss label is a <FormattedMessage> element, so it never
  // matches and stays "primary"; Select's is the plain string 'Cancel'
  // (see SelectFromWaitlist/constants.js), which resolves to "text". Falling
  // back like this — rather than hardcoding one variant — keeps all three
  // callers' refused-path dismiss button matching their permitted-path one.
  // dismissRest.variant, if the caller ever sets one, still wins via spread.
  const dismissVariant = ['Cancel', 'No'].includes(dismissLabel)
    ? 'text'
    : 'primary';

  return (
    <>
      <Button variant={dismissVariant} {...dismissRest}>
        {dismissLabel}
      </Button>
      <Tooltip title={tooltip} placement="top">
        <span>
          {/* No onClick: there is nothing to submit without the permission. */}
          <SubmitButton variant="primary" disabled isSubmitting={false}>
            {confirmLabel}
          </SubmitButton>
        </span>
      </Tooltip>
    </>
  );
};

export default PermissionGatedActions;
